import {Optional} from "./Optional";

export class StringUtil {

    public static titleCase(str: string): string {
        if (str.length === 0) {
            return str;
        } else {
            return str.replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase());
        }
    }

    public static format(str: string, args: Array<any>) {
        return str.replace(/%s/, (match, index) => Optional.of(args[index]).orElse(match));
    }

    /* https://stackoverflow.com/a/15710692 */
    public static hashCode(str: string): number {
        return str.split("").reduce((a, b) => {
            // tslint:disable:no-bitwise
            a = ((a << 5) - a) + b.charCodeAt(0);
            return a & a;
            // tslint:enable:no-bitwise
        }, 0);
    }

    public static isAlpha(char: string) {
        return (char >= "a" && char <= "z") || (char >= "A" && char <= "Z");
    }
}
